import { Checkbox } from '@cian/ui-kit';
import { ALL_PARKING_TYPES, EFacilityType } from '../../../../../../../packages/JsonQuery';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFacilitiesFilter } from 'shared/selectors/advancedFilters';
import { TModifier } from 'shared/types/filters';
import { formatToJsonQueryTermsValue } from 'shared/utils/jsonQuery';
import { InlineFiltersGrid } from 'shared/components/InlineFiltersGrid';

// опции с собственным term (не facilities-term  setFacilityTypes) объявляют свой модификатор здесь
const FACILITY_TOGGLE_MODIFIERS: Partial<Record<EFacilityType, (nextValue: EFacilityType[]) => TModifier>> = {
  [EFacilityType.Parking]: nextValue => ({
    action: 'setParkingType',
    arguments: [nextValue.includes(EFacilityType.Parking) ? ALL_PARKING_TYPES : null],
  }),
};

const getFacilitiesModifier = (nextValue: EFacilityType[]): TModifier => ({
  action: 'setFacilityTypes',
  arguments: [formatToJsonQueryTermsValue(nextValue.filter(facility => !FACILITY_TOGGLE_MODIFIERS[facility]))],
});

export const FacilitiesContainer: FC = () => {
  const { label, value, options } = useSelector(selectFacilitiesFilter);

  const onChange = useFilterChangeCallback();

  const handleFacilitiesChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, facility: EFacilityType) => {
      const { checked } = event.target;
      let nextValue: EFacilityType[] = value || [];

      switch (true) {
        case facility === EFacilityType.WithoutFurniture && checked:
          nextValue = nextValue.filter(v => ![EFacilityType.RoomFurniture, EFacilityType.KitchenFurniture].includes(v));
          nextValue.push(facility);
          break;
        case [EFacilityType.RoomFurniture, EFacilityType.KitchenFurniture].includes(facility) && checked:
          nextValue = nextValue.filter(v => v !== EFacilityType.WithoutFurniture);
          nextValue.push(facility);
          break;
        case checked:
          nextValue.push(facility);
          break;
        default:
          nextValue = nextValue.filter(v => v !== facility);
      }

      const getModifier = FACILITY_TOGGLE_MODIFIERS[facility] || getFacilitiesModifier;

      onChange(getModifier(nextValue));
    },
    [value, onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFiltersGrid>
        {options.map(facility => (
          <Checkbox
            key={facility.value}
            label={facility.label}
            checked={value ? value.includes(facility.value) : false}
            onChange={event => handleFacilitiesChange(event, facility.value)}
          />
        ))}
      </InlineFiltersGrid>
    </AdvancedFilterRow>
  );
};
